<template>
  <CContainer fluid>
    <CRow alignHorizontal="between">
      <div class="row-card-title left">
        <div>
          <div class="card-title-active">Name List</div>
          <div class="line" />
        </div>
      </div>
    </CRow>
    <CRow>
      <div class="main-card">
        <CContainer fluid>
          <CRow>
            <div style="margin-left:15px">
              <h3>Section {{ nameListData.courseDetail[0].code }}</h3>
            </div>
          </CRow>
          <CRow style="margin-top:20px">
            <CCol>
              <CDataTable
                responsive
                :items="dataContainer"
                :fields="fields"
                striped
                pagination
                sorter
                border
                style
                outlined
                columnFilter
                :itemsPerPage="100"
              >
                <template #progress="{ item }">
                  <td class="align-items-center">
                    <div style="font-weight: bold">
                      <i
                        class="fas fa-certificate"
                        :style="item.progressColor"
                      ></i>
                      {{ item.progress.toUpperCase() }}
                    </div>
                  </td>
                </template>
              </CDataTable>
            </CCol>
          </CRow>
        </CContainer>
      </div>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: "nameList",
  props: {
    nameListData: Object,
  },
  data() {
    return {
      items: [],
      fields: [],
      dataContainer: [],
    };
  },
  watch: {
    nameListData() {
      this.setData();
    },
  },
  created() {
    this.setData();
  },
  mounted() {
    this.fields = [
      { key: "num", label: "NUM", filter: false },
      { key: "userid", label: "USER ID" },
      { key: "name", label: "NAME" },
      { key: "school", label: "SCHOOL" },
      { key: "institution", label: "INSTITUTION" },
      { key: "progress", label: "PROGRESS" },
    ];
  },
  methods: {
    setData() {
      this.dataContainer = [];
      // for (let i = 0; i < this.nameListData.userDetail.length; i++) {
      //   var userCodeHolder = "";
      //   if (this.nameListData.userDetail[i].userId.codeId == null) {
      //     userCodeHolder = "None";
      //   } else {
      //     userCodeHolder = this.nameListData.userDetail[i].userId.codeId;
      //   }
      //   var userNameHolder = "";
      //   if (
      //     this.nameListData.userDetail[i].userId.userinfo.userinfo
      //       .displayname == null ||
      //     this.nameListData.userDetail[i].userId.userinfo.userinfo
      //       .displayname == "" ||
      //     typeof this.nameListData.userDetail[i].userId.userinfo.userinfo
      //       .displayname == undefined
      //   ) {
      //     userNameHolder =
      //       this.nameListData.userDetail[i].userId.userinfo.userinfo.firstname +
      //       " " +
      //       this.nameListData.userDetail[i].userId.userinfo.userinfo.lastname;
      //   } else {
      //     userNameHolder = this.nameListData.userDetail[i].userId.userinfo
      //       .userinfo.displayname;
      //   }
      //   var userSchoolHolder = "";
      //   if (
      //     this.nameListData.userDetail[i].userId.userinfo.education.faculty
      //       .length == 0
      //   ) {
      //     userSchoolHolder = "No School";
      //   } else {
      //     userSchoolHolder =
      //       typeof this.nameListData.userDetail[i].userId.userinfo.education
      //         .faculty[0].val == undefined
      //         ? "No School"
      //         : this.nameListData.userDetail[i].userId.userinfo.education
      //             .faculty.length >= 2
      //         ? this.nameListData.userDetail[i].userId.userinfo.education
      //             .faculty[1].val
      //         : "No School";
      //   }
      //   var userInstitutionHolder = "";
      //   if (
      //     this.nameListData.userDetail[i].userId.userinfo.education.length == 0
      //   ) {
      //     userInstitutionHolder = "No Institution";
      //   } else {
      //     userInstitutionHolder =
      //       this.nameListData.userDetail[i].userId.userinfo.education.name
      //         .length == 0
      //         ? "No Institution"
      //         : this.nameListData.userDetail[i].userId.userinfo.education.name
      //             .length >= 2
      //         ? this.nameListData.userDetail[i].userId.userinfo.education
      //             .name[1].val
      //         : "No Institution";
      //   }
      //   var userProgressHolder = "";
      //   var progressColor = "";
      //   if (this.nameListData.userDetail[i].complete == true) {
      //     userProgressHolder = "COMPLETED";
      //     progressColor = "color: #0BB190";
      //   } else if (this.nameListData.userDetail[i].unenroll == true) {
      //     userProgressHolder = "UNENROLLED";
      //     progressColor = "color: #F27979";
      //   } else {
      //     userProgressHolder = "IN PROGRESS";
      //     progressColor = "color: #F2DE79";
      //   }
      //   this.items = {
      //     num: i + 1,
      //     userid: userCodeHolder,
      //     name: userNameHolder,
      //     school: userSchoolHolder,
      //     institution: userInstitutionHolder,
      //     progress: userProgressHolder,
      //     progressColor: progressColor,
      //   };
      //   this.dataContainer.push(this.items);
      // }
      for (let i = 0; i < this.nameListData.userDetail.length; i++) {

        var userCodeHolder = "";
        var userNameHolder = "";
        var userSchoolHolder = "";
        var userInstitutionHolder = "";
        var userProgressHolder = "";
        var progressColor = "";

        if (this.nameListData.userDetail[i].codeId == null) {
          userCodeHolder = "None";
        } else {
          userCodeHolder = this.nameListData.userDetail[i].codeId;
        }
        
        if (
          this.nameListData.userDetail[i].displayname == null ||
          this.nameListData.userDetail[i].displayname == "" ||
          typeof this.nameListData.userDetail[i].displayname == undefined
        ) {
          userNameHolder = this.nameListData.userDetail[i].firstname + " " +this.nameListData.userDetail[i].lastname;
        } else {
          userNameHolder = this.nameListData.userDetail[i].displayname;
        }
        
        if (this.nameListData.userDetail[i].faculty.length == 0
        ) {
          userSchoolHolder = "No School";
        } else {
          userSchoolHolder =
            typeof this.nameListData.userDetail[i].faculty[0].val == undefined ? "No School"
              : this.nameListData.userDetail[i].faculty.length >= 2
              ? this.nameListData.userDetail[i].faculty[1].val
              : "No School";
        }
        
        if (this.nameListData.userDetail[i].schoolName.length == 0) {
          userInstitutionHolder = "No Institution";
        } else {
          userInstitutionHolder = this.nameListData.userDetail[i].schoolName.length == 0
              ? "No Institution"
              : this.nameListData.userDetail[i].schoolName.length >= 2
              ? this.nameListData.userDetail[i].schoolName[1].val
              : "No Institution";
        }
        
        if (this.nameListData.userDetail[i].complete == true) {
          userProgressHolder = "COMPLETED";
          progressColor = "color: #0BB190";
        } else if (this.nameListData.userDetail[i].enroll == false) {
          userProgressHolder = "UNENROLLED";
          progressColor = "color: #F27979";
        } else {
          userProgressHolder = "IN PROGRESS";
          progressColor = "color: #F2DE79";
        }
        this.items = {
          num: i + 1,
          userid: userCodeHolder,
          name: userNameHolder,
          school: userSchoolHolder,
          institution: userInstitutionHolder,
          progress: userProgressHolder,
          progressColor: progressColor,
        };
        this.dataContainer.push(this.items);
      }
    },
  },
};
</script>
